export default {
  downtimeUrl: "https://cl.kodland.tech",
  showAgeRules: true,
  parameters: {
    landing_id: "TrQTeen",
    segment: 43,
    success_page: 'turkey_teens',
    teenagers: 'true',
  },
  startPage: {
    image: "/welcome/tr-teens-desk.png",
    imageMobile: "/welcome/tr-teens-mob.png",
    title: "Ücretsiz dersinizi almak ve ilk programınızı oluşturmak için birkaç kısa soruyu yanıtlayın",
    subtitle: "Kayıt sadece 2 dakika sürer. Ders küçük bir grupla yapılacaktır. Size uygun bir gün ve saat seçebilirsiniz.",
    button: "Başlayın 🚀",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Okulda en sevdiğiniz ders nedir? ",
      answers: [
        "🔬 Fen bilimleri",
        "🎨 Sanat ve tasarım",
        "💻 Bilgisayar bilimi",
        "📙 Tarih, Edebiyat",
        "📐 Matematik",
        "💬 Yabancı diller",
        "🤩 Tüm dersler",
        "🤔 Emin değilim",
      ],
    },
    2: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: [
        {
          answer: "💻 Evet",
          distribution_tag_question: [18],
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true,
        },
      ],
    },
    3: {
      question: "Bilgisayar becerileriniz var mı? ",
      answers: [
        "😌 Evet, Microsoft Word/PowerPoint",
        "🖥 Evet, temel kodlama",
        "👍 Evet, ben bir oyuncuyum (Roblox, Minecraft)",
        "🤔 Hayır",
      ],
    },
    4: {
      title: "Yolu yarıladık! Yaşınızı seçin, böylece ona göre bir sınıf oluşturabiliriz",
      type: "age",
      button: "İleri 🚀",
    },
    5: {
      title: "Ücretsiz çevrimiçi ders için ne zaman müsaitsiniz?",
      type: "timeslot",
      subtitle:
        "Yerinizi ayırtmak için sadece birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    6: {
      title: "Adınızı giriniz",
      type: "parent_name",
      field_name: "parent_name",
      subtitle: "Biz Kodland, peki ya sen kimsin 👀",
      button: "İleri 🚀",
    },
    7: {
      title: "Telefon numaranızı girin",
      type: "phone",
      field_name: "parent_phone",
      subtitle:
        "Sizi sınıfın WhatsApp sohbetine ekleyeceğiz 💬",
      button: "Neredeyse bitti 🔥",
    },
    8: {
      title: "Ebeveyninizin adını girin",
      type: "custom_name",
      subtitle: "Derse kaydolmanız için buna ihtiyacımız var ✅",
    },
    9: {
      title: "Ebeveyninizin telefon numarasını girin",
      type: "custom_phone",
      subtitle: "Derse kaydolmanız için buna da ihtiyacımız var 👌",
    },
    10: {
      title: "Son adım ve bitti! Ebeveyninizin e-postası girin",
      type: "custom_email",
      field_name: "child_email",
      subtitle: "Derse kaydolmanız için buna da ihtiyacımız var 👌",
    },
  },
};
